export const notificationLinkStyle = {
  color: "#007bff",
  textDecoration: "underline",
} as const;

export const notificationButtonStyle = {
  ...notificationLinkStyle,
  background: "none",
  border: "none",
  padding: 0,
  cursor: "pointer",
  font: "inherit",
} as const;

